
export const PaymentOptions = {
    AUTOMATIC_SOCIAL: 'Automatic Deduction from Social Security benefit check',
    AUTOMATIC_RAILROAD: 'Automatic Deduction from Railroad Retirement Board benefit check',
    ELECTRONIC_FUND_TRANSFER: 'Automatic Bank Draft Withdrawal from Checking or Savings Account',
    MONTHLY_INVOICE: 'Monthly payments by check'
}

export const PaymentOptionsValues = {
    AUTOMATIC_SOCIAL: 'Automatic Deduction from Social Security benefit check',
    AUTOMATIC_RAILROAD: 'Automatic Deduction from Railroad Retirement Board benefit check',
    ELECTRONIC_FUND_TRANSFER: 'Automatic Bank Draft Withdrawal from Checking or Savings Account',
    MONTHLY_INVOICE: 'Monthly payments by check'
}

export type PaymentOption = 'ELECTRONIC_FUND_TRANSFER' | 'AUTOMATIC_SOCIAL' | 'AUTOMATIC_RAILROAD' | 'MONTHLY_INVOICE'
